import styled from "styled-components";
import { Color, Font, breakpoints } from "@/shared/Constants";
import { TwoxOneWH  } from "../mixins-modules"; 
export const ContentTwoxOneNoImage = styled.div`
    ${TwoxOneWH}
    ${breakpoints.tablet} {
        width:308px;
      }
    .mt{
        h2.title{
            font-size: 33px;
            line-height: 37px;
            ${breakpoints.phone} {
                font-size:27px;
                line-height: 31px;
            }
        }
        .volanta{
            font-size: 33px;
            line-height: 37px;
            ${breakpoints.tablet} {
                font-size:27px;
                line-height: 31px;
            }
            ${breakpoints.phone} {
                font-size:27px;
                line-height: 31px;
            }
        }
        .bajada{ 
            margin: 10px 0 0;
        }
        .data-txt{
            order:3;
            margin: 15px 0 0;
        }
    }
        ${breakpoints.tablet} {
            .related{
                display:none;
            }
        }
`;
